import React from 'react'
import { useMemo } from 'react'
import { isAfter } from 'date-fns'

export default function WarningMessage({
  dateToDisplay,
  message,
}: {
  dateToDisplay: string
  message: string
}) {
  const showPostQHackMessage = useMemo(() => {
    const today = new Date()
    return message && !!dateToDisplay && isAfter(today, new Date(dateToDisplay))
  }, [dateToDisplay])

  return showPostQHackMessage ? (
    <div
      className="bg-[#FFEED4] border border-qhack-2024-orange-4 px-3 py-2 rounded-[5px] mb-4"
      data-testid="leaderboard-announcement"
    >
      <p
        role="alert"
        aria-live="polite"
        className="font-sora text-qhack-2024-navy-1 text-base leading-[1.6rem] my-0"
      >
        {message}
      </p>
    </div>
  ) : null
}
